export default __webpack_public_path__ + "static/media/sue1.c6bf28e5.jpg";